'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dProxy$002dName$0024 from "./presto.types$-Proxy-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_Proxies$$anon$4(outer) {
  this.bqK = null;
  this.bqI = null;
  this.bqJ = false;
  this.bqG = null;
  this.bqH = false;
  this.bqL = false;
  this.bqM = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bqK = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_Proxies$$anon$4 as $c_Lpresto_Proxies$$anon$4 };
$p = $c_Lpresto_Proxies$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Proxies$$anon$4;
/** @constructor */
function $h_Lpresto_Proxies$$anon$4() {
}
export { $h_Lpresto_Proxies$$anon$4 as $h_Lpresto_Proxies$$anon$4 };
$h_Lpresto_Proxies$$anon$4.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bqK;
});
$p.t = (function() {
  if ((!this.bqJ)) {
    this.bqI = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bqJ = true;
  }
  return this.bqI;
});
$p.ae = (function() {
  if ((!this.bqH)) {
    this.bqG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dProxy$002dName$0024.$m_Lpresto_types$ProxyName$().cs6(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bqH = true;
  }
  return this.bqG;
});
$p.w = (function() {
  if ((!this.bqM)) {
    this.bqL = false;
    this.bqM = true;
  }
  return this.bqL;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_Proxies$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Proxies$$anon$4, "presto.Proxies$$anon$4", ({
  Pd: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_Proxies$$anon$4 as $d_Lpresto_Proxies$$anon$4 };
//# sourceMappingURL=presto.-Proxies$$anon$4.js.map
